import { defineStore, _ActionsTree, _GettersTree } from "pinia";
import _ from "lodash";
// import { Modal } from "bootstrap";
import PubApi from "~/serverapi/Public";
import type { ItemValue, AlertItem } from "composables/use-interface";
import { Modal } from "bootstrap";
import { promises } from "dns";
import http from "~/serverapi/http";
export interface WarningModelFace {
	show: boolean;
	header?: {
		show?: boolean;
		title?: string;
		class?: string;
	};
	body: {
		content: string;
		class?: string;
	};
	footer?: {
		show?: boolean;
		submit?: string;
		close?: string;
		class?: string;
		closeClass?: string;
		submitClass?: string;
	};
	submitFunc?(close: any): any | null;
	closeFunc?(close: any): any | null;
	type?: string;
	size?: string;
	center?: boolean;
}
interface outData {
	gender: Array<ItemValue>;
	flyseet: Array<ItemValue>;
	jobTitle: Array<ItemValue>;
	collectStatus: Array<ItemValue>;
	called: Array<any>;
	clienttable: Array<any>;
	IncomeEleType: Array<ItemValue>;
}
// 將其命名為useXXXStore，就像vue3的composable一樣
export interface StoreState {
	companyInfo: any;
	lang: string;
	isHeader: boolean;
	routeTran: boolean;
	langList: Array<ItemValue>;
	selectFunc: string;
	loading: boolean;
	messageshow: boolean;
	sideListGroup: any;
	sideList: any;
	AlertList: Array<AlertItem>;
	DOCmodal: null | Modal;
	WarningModel: WarningModelFace;
	asyncList: any;
	outData: outData;
	pointIcon: any;
	responseObj: any;
}

// 建議以initState先聲明在useStore之前，這樣比較好用，尤其是reset的情況特別好用
//  process && process.client ? (localStorage.getItem("language") || "zh-tw") :
const initState: StoreState = {
	companyInfo: {
		name: "",
		nickname: "",
		engName: "",
		content: "",
		smallIcon: "",
		bigIcon: "",
		photo: "",
		indexImage: "",
		taxId: "",
		country: "",
		city: "",
		area: "",
		address: "",
		serviceArea: "",
		phone: "",
		engLocation: "",
		useSchedule: "",
		documentNo: "",
		QAMember: "",
	},
	lang: "zh-tw",
	langList: [],
	selectFunc: "",
	loading: false,
	isHeader: true,
	messageshow: false,
	sideListGroup: [],
	sideList: [],
	AlertList: [],
	DOCmodal: null,
	asyncList: {},
	WarningModel: <WarningModelFace>{
		show: false,
		header: {
			show: true,
			title: "hello",
			class: "",
		},
		body: {
			content: "",
			class: "",
		},
		footer: {
			show: true,
			submit: "Submit",
			close: "Close",
			class: "",
			closeClass: "btn-secondary",
			submitClass: "btn-primary",
		},
		submitFunc(close) {
			close();
		},
		closeFunc(close) {
			close();
		},
		type: "alert",
	},
	routeTran: false,
	outData: {
		flyseet: [
			{
				name: "無機位",
				values: "",
			},
			{
				name: "頭等(F)",
				values: "F",
			},
			{
				name: "商務艙(C)",
				values: "C",
			},
			{
				name: "經濟艙(Y)",
				values: "Y",
			},
		],
		called: <Array<any>>[
			{
				name: "Mr/先生",
				values: "mr",
				sex: "male",
				age: {
					start: 12,
				},
			},
			{
				name: "Ms/小姐",
				values: "ms",
				sex: "female",
				age: {
					start: 12,
				},
			},
			{
				name: "Mstr/小男孩",
				values: "mstr",
				sex: "male",
				age: {
					start: 2,
					end: 12,
				},
			},
			{
				name: "Mrs/小女孩",
				values: "mrs",
				sex: "female",
				age: {
					start: 2,
					end: 12,
				},
			},
			{
				name: "Infant/嬰兒",
				values: "infant",
				sex: "",
				age: {
					end: 2,
				},
			},
		],
		gender: [
			{
				name: "不公開",
				values: "noopen",
			},
			{
				name: "男",
				values: "male",
			},
			{
				name: "女",
				values: "female",
			},
		],
		jobTitle: [
			{
				name: "總經理",
				values: "General_manager",
			},
			{
				name: "經理",
				values: "manager",
			},
			{
				name: "主管",
				values: "director",
			},
			{
				name: "業務",
				values: "saler",
			},
		],
		collectStatus: [
			{
				name: "待處理",
				values: 0,
			},
			{
				name: "託收",
				values: 2,
			},
			{
				name: "兌現",
				values: 1,
			},
			{
				name: "退票",
				values: 4,
			},
		],

		clienttable: [
			{
				name: "廠商",
				values: "Vendor",
			},
			{
				name: "會員",
				values: "member",
			},
			{
				name: "訂購人",
				values: "TravelOrder",
			},
			{
				name: "訂單旅客",
				values: "TravelOrderInfo",
			},
		],
		IncomeEleType: [],
	},

	pointIcon: {
		point: ["fas", "location-dot"],
		restaurant: ["fas", "utensils"],
		hotel: ["fas", "house"],
		traffic: ["fas", "bus-simple"],
		other: ["fas", "gears"],
		"": ["fas", "gears"],
	},
	responseObj: {
		active: {},
		error: [],
	},
};
const htmlspecialchars = (str: string = "") => {
	var s = "";
	if (str.length == 0) return "";
	for (var i = 0; i < str.length; i++) {
		switch (str.substr(i, 1)) {
			case "<":
				s += "&lt;";
				break;
			case ">":
				s += "&gt;";
				break;
			case "&":
				s += "&amp;";
				break;
			case " ":
				if (str.substr(i + 1, 1) == " ") {
					s += " &nbsp;";
					i++;
				} else s += " ";
				break;
			case '"':
				s += "&quot;";
				break;
			case "\\":
				s += "&OS;";
				break;
			case "/":
				s += "&OA;";
				break;
			case "\n":
				s += "<br>";
				break;
			default:
				s += str.substr(i, 1);
				break;
		}
	}
	return s;
};
const getters: _GettersTree<StoreState> = {
	getSelectLang: (state): string => {
		return state.lang;
	},
	LoadingShow: (state): boolean => {
		return _.size(state.asyncList) > 0;
	},
	// getTripleCount: (state) => state.count * 3,
};
const useStore = defineStore("Public", {
	state: () => initState,
	actions: {
		async getMenu(method: string = "") {
			this.loading = true;
			const res = await PubApi.getMenu(method);
			this.loading = false;
			this.sideList = res.result.func;
			this.sideListGroup = res.result.group;
			return res;
		},
		loadData() {
			// this.sideList = useFuncList();
			// this.sideListGroup = useFuncGroup();
			this.langList = useLangList();
		},
		getStroke(uid: string) {
			return PubApi.getStroke(uid);
		},

		saveDay(data: any) {
			return PubApi.saveDay(data);
		},

		getField(folder: any, page = 0, pagenumber = 20) {
			return PubApi.getField(folder, page, pagenumber);
		},

		insertSystemImage(data: any) {
			// return http.post("Pub/insertSystemImage", data);
			return PubApi.insertSystemImage(data);
		},

		saveFolder(data: any) {
			// return http.post("Pub/saveFolder", data);
			return PubApi.saveFolder(data);
		},

		moveField(data: any) {
			// return http.post("Pub/moveField", data);
			return PubApi.moveField(data);
		},

		getLogData(agency: string) {
			return PubApi.getLogData(agency);
		},

		htmlspecialchars: htmlspecialchars,

		setTransferClass(agency: string, data: any) {
			return PubApi.setTransferClass(agency, data);
		},

		getTransferClass(agency: string) {
			return PubApi.getTransferClass(agency);
		},

		auto(agency: string, field: any) {
			return PubApi.auto(agency, field);
		},

		autoOutData(agency: string) {
			return PubApi.autoOutData(agency);
		},

		autoStroke(agency: string) {
			return PubApi.autoStroke(agency);
		},

		getOutData(agency: string, search: any) {
			return PubApi.getOutData(agency, search);
		},

		updateOutData(agency: string, data: any) {
			return PubApi.updateOutData(agency, data);
		},
		importOutData(agency: string, data: any) {
			return PubApi.importOutData(agency, data);
		},
		updateTourOutData(agency: string, data: any) {
			return PubApi.updateTourOutData(agency, data);
		},
		importTourOutData(agency: string, data: any) {
			return PubApi.importTourOutData(agency, data);
		},

		cancelAllFetch() {
			return http.cancelFetch();
		},
		cancelFetch(ar: Array<string> = []) {
			http.cancelFetch(ar);
		},
		getPubData(table: string) {
			return PubApi.pbRequest(table);
		},
		getPubMultiData(table: Array<string>) {
			return PubApi.pbMultiRequest(table);
		},
		setLang(data: string) {
			this.lang = data;
			localStorage.setItem("language", data);
		},
		setAlertList(data: AlertItem) {
			const TmpRendom = "ALT" + Math.random() * 999999;
			data.uid = TmpRendom;
			data.color = data.color || "success";
			data.textColor = data.textColor || "white";
			this.AlertList.push(data);
			setTimeout(() => {
				this.removeAlertList(TmpRendom);
			}, data.removeTime || 1500);
		},
		levelAlert(title: string = "無權限", content: string = "無權限執行") {
			this.openWarningModel({
				show: true,
				type: "alert",
				header: {
					title: title,
				},
				body: {
					content: content,
				},
				footer: {
					close: "關閉",
					closeClass: "btn-danger",
				},
			});
		},
		openWarningModel(data: WarningModelFace) {
			// if (process.client && !this.DOCmodal) {
			//   const { $bootstrap } = useNuxtApp();
			//   this.DOCmodal = new $bootstrap.Modal(document.getElementById('WarningModal'), {
			//     backdrop: "static"
			//   });
			// }
			_.each(data.header || [], (item, keys) => {
				this.WarningModel.header[keys] = item;
			});
			_.each(data.body || [], (item, keys) => {
				this.WarningModel.body[keys] = item;
			});
			_.each(data.footer || [], (item, keys) => {
				this.WarningModel.footer[keys] = item;
			});
			this.WarningModel.submitFunc =
				data.submitFunc ||
				((close) => {
					close();
				});
			this.WarningModel.closeFunc =
				data.closeFunc ||
				((close) => {
					close();
				});
			this.WarningModel.type = data.type || this.WarningModel.type;
			this.WarningModel.size = data.size;
			this.WarningModel.center = data.center;
			this.WarningModel.show = true;
			// this.DOCmodal.show();
		},
		CloseWarningModel() {
			this.WarningModel = { ...initState.WarningModel };
			this.WarningModel.show = false;
		},
		removeAlertList(data: string) {
			const index = _.findLastIndex(this.AlertList, { uid: data });
			this.AlertList.splice(index, 1);
		},
		async getDatainfo(func = <string>"", where = {}, params = "") {
			let usePublic = <any>null;
			try {
				if (["getCountry", "getPaySource", "getCurrency"].indexOf(func) > -1) {
					usePublic = await PubApi[func](where);
				} else {
					usePublic = await PubApi[func](params, where);
				}
			} catch (e) {
				console.log(e);
			}
			return usePublic;
		},
		async getMulitData(tableList: Array<any>, cancelFuncList: any = null) {
			// const cancelFuncList = _.map(tableList, (item, keys) => {
			// 	return item.table;
			// }).join(",");
			return await PubApi.getMulitData(tableList, cancelFuncList);
		},
		SendforgotPwd(taxId: string, email: string) {
			return PubApi.SendforgotPwd(taxId, email);
		},
		CheckShortUrl(code: string) {
			return PubApi.CheckShortUrl(code);
		},
		forgotchangePwd(pwd: string, code: string) {
			return PubApi.forgotchangePwd(pwd, code);
		},

		getWebImage(website: string) {
			return PubApi.getWebImage(website);
		},

		getPointImage(data: Object) {
			return PubApi.getPointImage(data);
		},

		editSpecial(data: Object) {
			return PubApi.editSpecial(data);
		},

		editSpecialItem(data: Object) {
			return PubApi.editSpecialItem(data);
		},

		editSpecialPackage(data: Object) {
			return PubApi.editSpecialPackage(data);
		},
		deleteSpecialItem(data: string) {
			return PubApi.deleteSpecialItem(data);
		},
		deleteSpecial(data: string) {
			return PubApi.deleteSpecial(data);
		},
		deleteSpecialPackage(data: string) {
			return PubApi.deleteSpecialPackage(data);
		},

		editRemark(data: Object) {
			return PubApi.editRemark(data);
		},
		deleteRemark(data: string) {
			return PubApi.deleteRemark(data);
		},

		editRemarkItem(data: Object) {
			return PubApi.editRemarkItem(data);
		},
		deleteRemarkItem(data: string) {
			return PubApi.deleteRemarkItem(data);
		},

		editRemarkPackage(data: Object) {
			return PubApi.editRemarkPackage(data);
		},
		deleteRemarkPackage(data: string) {
			return PubApi.deleteRemarkPackage(data);
		},

		async getFlightBoard(search: any, page: number, pagenumber: number | "all") {
			return PubApi.getFlightBoard(search, page, pagenumber);
		},

		async getSpecial(search: any, page: number, pagenumber: number | "all", method: string | "tempSpecial") {
			return PubApi.getSpecial(search, page, pagenumber, method);
		},

		async getSpecialPackage(search: any, page: number, pagenumber: number | "all") {
			return PubApi.getSpecialPackage(search, page, pagenumber);
		},

		async getSpecialPackageItem(uid: any) {
			return PubApi.getSpecialPackageItem(uid);
		},

		async getRemark(search: any, page: number, pagenumber: number | "all", method: string | "tempRemark") {
			return PubApi.getRemark(search, page, pagenumber, method);
		},

		async getRemarkPackage(search: any, page: number, pagenumber: number | "all") {
			return PubApi.getRemarkPackage(search, page, pagenumber);
		},

		async getRemarkPackageItem(uid: any) {
			return PubApi.getRemarkPackageItem(uid);
		},

		getAirLine(where: any = null, page: any = 0, pagenumber: any = "all") {
			return PubApi.getAirLine(where, page, pagenumber);
		},

		getAirPort(where: any = null, page: any = 0, pagenumber: any = "all") {
			return PubApi.getAirPort(where, page, pagenumber);
		},
		sendMessage(formdata: any) {
			return PubApi.sendMessage(formdata);
		},
		SetSendManage(method: string, formdata: any) {
			return PubApi.SetSendManage(method, formdata);
		},
		getSendManage(method: string) {
			return PubApi.getSendManage(method);
		},
		getMsgPoint() {
			return PubApi.getMsgPoint();
		},
		getPassportConverterChin(firstname: string, lastname: string) {
			return PubApi.getPassportConverterChin(firstname, lastname);
		},
		getLocationToEng(location: string) {
			return PubApi.getLocationToEng(location);
		},
		getAgencySource() {
			return PubApi.getAgencySource();
		},
		getNoticeMessage(page: number = 0, pagenumber: number = 20, where: any = {}) {
			return PubApi.getNoticeMessage(page, pagenumber, where);
		},
		readNoticeMessage(uid: string) {
			return PubApi.readNoticeMessage(uid);
		},
		autoSave(
			maintable: string,
			main: any,
			sub: Array<{
				mainfield: string;
				subfield: string;
				subtable: string;
				subdata: Array<any>;
			}>,
			cancelfunc = null,
		) {
			return PubApi.autoSave(maintable, main, sub, cancelfunc);
		},
		async getCompanyInfo() {
			const res = await PubApi.getCompanyInfo();
			this.companyInfo = res.result.info;
		},
		getAdjustList(method: string, belong_uid: string, page: number = 0, pagenumber: number = 20) {
			return PubApi.getAdjustList(method, belong_uid, page, pagenumber);
		},
		getAdjustInfo(uid: string) {
			return PubApi.getAdjustInfo(uid);
		},
		EditAdjust(uid: string, formdata: any) {
			return PubApi.EditAdjust(uid, formdata);
		},
		createEDCard(data: any) {
			return PubApi.createEDCard(data);
		},
		getEDCardSetting() {
			return PubApi.getEDCardSetting();
		},
		deleteEDCardField(uid: string) {
			return PubApi.deleteEDCardField(uid);
		},
		editPnrSetting(data: any) {
			return PubApi.editPnrSetting(data);
		},
		getPnrSetting() {
			return PubApi.getPnrSetting();
		},
		editPnrStroke(data: any) {
			return PubApi.editPnrStroke(data);
		},
		setPnrCode(data: any) {
			return PubApi.setPnrCode(data);
		},
		editCustomForm(data: any) {
			return PubApi.editCustomForm(data);
		},
		deleteCustomForm(uid: string) {
			return PubApi.deleteCustomForm(uid);
		},
		readReadNotice(uid: string) {
			return PubApi.readReadNotice(uid);
		},
		doingPid(method: string, pid: any) {
			return PubApi.doingPid(method, pid);
		},
		GoogleOcr(image: string, sourceUid: string = "") {
			return PubApi.GoogleOcr(image, sourceUid);
		},
		getSysHistory(method: string, page: number = 0, pagenumber: number | string = 20, search: any = {}) {
			return PubApi.getSysHistory(method, page, pagenumber, search);
		},

		EditAdjustAcoount(data: any) {
			return PubApi.EditAdjustAcoount(data);
		},

		AdjustAcoountList(searchData: any = {}, page: string | number = 0, pagenumber: string | number = 20, orderBy: OrderBy = { name: "createtime", order: "desc" }) {
			return PubApi.AdjustAcoountList(JSON.stringify(searchData), page, pagenumber, orderBy);
		},
	},
	getters,
});
export default useStore;
